import { Window } from "@progress/kendo-react-dialogs";
import {
  columnsConstructorSessionData,
  editedPropertyValues as editedColumnPropertyValues,
  selectedColumnId,
} from "../../Fields/ColumnsConstructor/ColumnsConstructorSignals";
import {
  fieldFocusIndex,
  isGalleryEditor,
  selectedSectionName,
  selectedFieldName as selectedTemplateFieldName,
  templateData,
} from "../../Template/NewTemplateSignals";
import {
  editedPropertyValues,
  selectedFieldName,
} from "../GalleryConstructor/GalleryConstructorSignals";
import { expressionBuilderVisibility } from "../Store/CommonSignals";
import ExpressionBuilder from "./ExpressionBuilder";

export const ExpressionBuilderWindow = () => {
  const handlePropertyChange = ({ propName, propValue }) => {
    if (isGalleryEditor.value) {
      editedPropertyValues.value = {
        ...editedPropertyValues.value,
        [selectedFieldName.value]: {
          ...editedPropertyValues.value[selectedFieldName.value],
          [propName]: propValue,
        },
      };
    } else if (columnsConstructorSessionData.value.length > 0) {
      editedColumnPropertyValues.value = {
        ...editedColumnPropertyValues.value,
        [selectedColumnId.value]: {
          ...editedColumnPropertyValues.value[selectedColumnId.value],
          [propName]: propValue,
        },
      };
    } else if (fieldFocusIndex.value === null) {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              properties: {
                ...section.properties,
                [propName]: propValue,
              },
            };
          }
          return section;
        }),
      };
    } else {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              fields: section.fields.map((field) => {
                if (field.fieldName === selectedTemplateFieldName.value) {
                  return {
                    ...field,
                    properties: {
                      ...field.properties,
                      [propName]: propValue,
                    },
                  };
                }
                return field;
              }),
            };
          }
          return section;
        }),
      };
    }
  };

  return (
    <>
      {expressionBuilderVisibility.value && (
        <Window
          onClose={() => (expressionBuilderVisibility.value = false)}
          className="expression-builder-window"
          initialHeight={900}
          initialWidth={1600}
          title={"Expression Builder"}
        >
          <ExpressionBuilder
            handlePropertyChange={handlePropertyChange}
            onClose={() => {
              expressionBuilderVisibility.value = false;
            }}
          />
        </Window>
      )}
    </>
  );
};
